import { FieldValues, UseFormSetError } from 'react-hook-form'

interface ErrorObject {
  type: string
  message: string
}

interface ErrorDictionary {
  [key: string]: ErrorObject
}

export const generateErrorHTML = (
  errors: ErrorDictionary,
  setError?: (
    field: string,
    message: {
      type: string
      message: string
    }
  ) => UseFormSetError<FieldValues>
): string => {
  let errorHTML = ''
  for (const field in errors) {
    if (errors.hasOwnProperty(field)) {
      const error = errors[field]

      if (Array.isArray(error)) {
        // Handle array of error messages
        error.forEach(errorMessage => {
          if (setError) {
            setError(field, { type: 'manual', message: errorMessage })
          }

          errorHTML += `${errorMessage}<br>`
        })
      } else {
        // Handle single error object
        errorHTML += `${error.message}<br>`
      }
    }
  }

  return errorHTML
}
